import React, { useEffect, useState } from "react";
import { giCTMTConAdd, CTMTContract, tmCTMTContract, cpCTMTContract, liCTMTContract, giCTMTContract } from "./ConAddsAndABIs"
import ChooseManager from "./ChooseManager";
import Provideractions from "./Provideractions";

function Providers(){

    const [walletAddress, setWalletAddress] = useState("");
    const [ctmtBalance, setCtmtBalance] = useState("''");
    const [managerId, setManagerId] = useState("");
    const [myManagerAddress, setMyManagerAddress] = useState("");
    const [redeemableGiCTMT, setRedeemableGiCTMT] = useState("");
    const [redeemableGiCTMTButton, setRedeemableGiCTMTButton] = useState("");
    const [rGiCTMTValue, setRGiCTMTValue] = useState("");
    const [redeemableLiCTMT, setRedeemableLiCTMT] = useState("0.00");
    const [redeemableLiCTMTButton, setRedeemableLiCTMTButton] = useState("");
    const [quitStatus, setQuitStatus] = useState("");
   
    const [forceRedeemLIButton, setForceRedeemLIButton] = useState("");
    const [forceRedeemGIButton, setForceRedeemGIButton] = useState("");

    const [cpCTMTBalance, setCpCTMTBalance] = useState('');
    const [minCpCTMT, setMinCpCTMT] = useState('');
    const [CTMTDeposits, setCTMTDeposits] = useState('');
    const [claimedReturns, setClaimedReturns] = useState('');
    const [totalSapphireSalt, setTotalSapphireSalt] = useState('');
    const [cwsMined, setCwsMined] = useState('');
    const [claimableReturns, setClaimableReturns] = useState('0.00');
    const [claimableReturnsButton, setClaimableReturnsButton] = useState('');    
    const [claimableLiCTMT, setClaimableLiCTMT] = useState('0.00');
    const [claimableGiCTMT, setClaimableGiCTMT] = useState('0.00');
    const [cGiCTMTValue, setCGiCTMTValue] = useState('0.00');


    useEffect(() => {  
        
        const getWalletAddress = async () => {
            const accounts = await window.ethereum.request({
                method: "eth_requestAccounts",
            });
            const account = accounts[0]
            const accountF = account.toString()
            setWalletAddress(accountF);
        }
        
        getWalletAddress()
            .catch(console.error)

        const getMyManagerAddress = async () => {
            const data = await cpCTMTContract.providersManager(walletAddress)
            const str = data.toString()
            setMyManagerAddress(str)
            }
    
        getMyManagerAddress()
            .catch(console.error)  
    
        const getCpCTMTBalance = async () => {
            const balance = await cpCTMTContract.balanceOf(walletAddress)
            const balanceFormatted = balance / (10**18)
            const commaSeparated = balanceFormatted.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setCpCTMTBalance(commaSeparated)
            }
  
        const getManagerId = async () => {
            const data = await tmCTMTContract.managerId(myManagerAddress)
            const dataF = data.toString()
              setManagerId(dataF)
          }

        getManagerId()
          .catch(console.error)             

        getCpCTMTBalance()
            .catch(console.error)  

        const getCTMTDeposits = async () => {
            const balance = await cpCTMTContract.provsCTMTDeps(walletAddress) / (10**18)
            const commaSeparated = balance.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setCTMTDeposits(commaSeparated)
            }
    
        getCTMTDeposits()
            .catch(console.error)  

            const getMinCpCTMT = async () => {
                const balance = await cpCTMTContract.cpCTMTIssued(walletAddress) / (10**18)
                const commaSeparated = balance.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                    setMinCpCTMT(commaSeparated)
                }
        
                getMinCpCTMT()
                .catch(console.error)  

        const getClaimedReturns = async () => {
            const produced = await cpCTMTContract.provsCTMTDeps(walletAddress) / (10**18)
            const minSeaWater = await cpCTMTContract.cpCTMTIssued(walletAddress) / (10**18)
            const sold = produced - minSeaWater
            const claimed = await cpCTMTContract.provClaimedRets(walletAddress) / (10**18)
            const cwsM = claimed - sold
            const claimedF = claimed.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            const soldF = sold.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            const cwsMF = cwsM.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setTotalSapphireSalt(claimedF)
                setClaimedReturns(soldF)
            if (cwsM < 0) {
                setCwsMined("0.00")
            } else if (cwsM >= 0) {
                setCwsMined(cwsMF)
            }

                
            }
    
        getClaimedReturns()
            .catch(console.error)  

        const getClaimableReturns = async () => {
            const quitS = await cpCTMTContract.quitted(walletAddress)
            const balance = await cpCTMTContract.checkClaimableRet(walletAddress, myManagerAddress) / (10**18)
            const minSeaWater = await cpCTMTContract.cpCTMTIssued(walletAddress) / (10**18)
            const commaSeparated = balance.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            const dissolStat = await tmCTMTContract.isDissolved(managerId)    
            let buttonName
                if (minSeaWater === 0) {
                    buttonName = "Claim Returned CWJC"
                } else if (minSeaWater > 0) {
                    buttonName = "Claim Free CWJC"
                }


                if (quitS === true) {
                    setClaimableReturns("0.00")
                } else if (quitS === false) {
                    setClaimableReturns(commaSeparated)
                }

                if (balance > 0 & dissolStat === false) {
                    setClaimableReturnsButton(<button style={{"fontSize":"12px"}} onClick={handleClaimReturns}>{buttonName}</button>)
                }
            }

        getClaimableReturns()
            .catch(console.error)  

        const getClaimableLiCTMT = async () => {
            const liCTMTBalofManager = await tmCTMTContract.liCTMTBal(managerId) / (10**18)
            const liCTMTClaimedFrManager = await cpCTMTContract.claimedLiCTMT(myManagerAddress) / (10**18)
            const cpBurned = await cpCTMTContract.manCpCTMTBurned(myManagerAddress) / (10**18)
            const cpIssued = await cpCTMTContract.cpCTMTIssued(walletAddress) / (10**18)
            const myCTMTDeps = await cpCTMTContract.provsCTMTDeps(walletAddress) / (10**18)
            const myManDeps = await cpCTMTContract.managersCTMTDeps(myManagerAddress) / (10**18)
            const claimedReturns = await cpCTMTContract.provClaimedRets(walletAddress) / (10**18)
            const claimableReturns = await cpCTMTContract.checkClaimableRet(walletAddress, myManagerAddress) / (10**18)
            const isQuitted = await  cpCTMTContract.quitted(walletAddress)

            if (isQuitted === false && (cpIssued - claimableReturns) > 0) {
                const myLiCTMTShare = (liCTMTBalofManager - liCTMTClaimedFrManager) * (cpIssued - claimableReturns) / (myManDeps - cpBurned - claimableReturns)
                if (myLiCTMTShare >= (cpIssued - claimableReturns)) {
                    const claimFrLI = myLiCTMTShare
                    const claimFrGI = 0
                    const formatclaimFrLI = claimFrLI.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                        setClaimableLiCTMT(formatclaimFrLI)  
                    const formatclaimFrGI = claimFrGI.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                        setClaimableGiCTMT(formatclaimFrGI)                                                    
                } 
                else {
                        const claimFrLI = myLiCTMTShare
                        const claimFrGI = (cpIssued - claimableReturns) - myLiCTMTShare
                        const giTS = await giCTMTContract.totalSupply() / (10**18)
                        const ctmtInGi = await CTMTContract.balanceOf(giCTMTConAdd) / (10**18)
                        const ctmtValueOfGi = ctmtInGi * (claimFrGI / (giTS + claimFrGI))
                        const formatclaimFrLI = claimFrLI.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            setClaimableLiCTMT(formatclaimFrLI)  
                        const formatclaimFrGI = claimFrGI.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            setClaimableGiCTMT(formatclaimFrGI) 

                        if (ctmtInGi < (giTS + claimFrGI)) {
                          const formatCtmtValueOfGi = ctmtValueOfGi.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                          setCGiCTMTValue(formatCtmtValueOfGi)                                
                        } else {
                          const formatCtmtValueOfGi = claimFrGI.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                          setCGiCTMTValue(formatCtmtValueOfGi)                                
                        }}
                    }                                                            
              }    

        getClaimableLiCTMT()
            .catch(console.error)  
 
        const getRedeemableGiCTMT = async () => {
            const balance = await giCTMTContract.redeemableGiCTMT(walletAddress) / (10**18)
            const giTS = await giCTMTContract.totalSupply() / (10**18)
            const ctmtInGi = await CTMTContract.balanceOf(giCTMTConAdd) / (10**18)
            const ctmtValueOfGi = ctmtInGi * balance / giTS            
            const commaSeparated = balance.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            
                setRedeemableGiCTMT(commaSeparated)

            if (ctmtInGi > giTS) { 
                const ctmtValueOfGiF = balance.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
                setRGiCTMTValue(ctmtValueOfGiF)}
            else {
                const ctmtValueOfGiF = ctmtValueOfGi.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
                setRGiCTMTValue(ctmtValueOfGiF)}

                const fdTime = await giCTMTContract.redemptionStart(walletAddress)
                const fdTimeF1 = new Date(fdTime * 1000)
                const timeNow = new Date()
    
                if (balance > 0 && timeNow >= fdTimeF1) {
                    setRedeemableGiCTMTButton(<button onClick={handleRedeemGiCTMT}>Redeem</button>)
                } else if (balance > 0 && timeNow < fdTimeF1) {
                    setForceRedeemGIButton(<button onClick={handleForceGIRedemption}>Force Redeem</button>)
                }    
        }
    
        getRedeemableGiCTMT()
            .catch(console.error)  
      
        const getRedeemableLiCTMT = async () => {
          const balance = await liCTMTContract.redeemableLiCTMT(walletAddress)
          const balanceFormatted = balance / (10**18)
          const commaSeparated = balanceFormatted.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            setRedeemableLiCTMT(commaSeparated)

            const fdTime = await liCTMTContract.redemptionStart(walletAddress)
            const fdTimeF1 = new Date(fdTime * 1000)
            const timeNow = new Date()

            if (balance > 0 && timeNow >= fdTimeF1) {
                setRedeemableLiCTMTButton(<button onClick={handleRedeemLiCTMT}>Redeem</button>)
            } else if (balance > 0 && timeNow < fdTimeF1) {
                setForceRedeemLIButton(<button onClick={handleForceLIRedemption}>Force Redeem</button>)
            }              
          }
  
      getRedeemableLiCTMT()
          .catch(console.error)              
  

        const getCtmtBalance = async () => {
          const balance = await CTMTContract.balanceOf(walletAddress)
          const balanceFormatted = balance / (10**18)
          const commaSeparated = balanceFormatted.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            setCtmtBalance(commaSeparated)
        }
    
        getCtmtBalance()
            .catch(console.error)         

        const getQuitStatus = async () => {
            const quitStat = await cpCTMTContract.quitted(walletAddress)
            if (quitStat === true) {
                setQuitStatus("Quitted")
            } else if (quitStat === false) {
                const wMan = await cpCTMTContract.withManager(walletAddress)
                if (wMan === true) {
                    setQuitStatus("Associated")
                } else if (wMan === false) {
                    setQuitStatus("No Manager Yet")
                }
            }
            }

            getQuitStatus()
            .catch(console.error)                  
                
    })

    const handleClaimReturns = async (e) => {
        e.preventDefault();
        const txn = await cpCTMTContract.claimReturns()
        await txn.wait();
        } 

    const handleRedeemLiCTMT = async (e) => {
      e.preventDefault();
      const txn = await liCTMTContract.redeemLiCTMT()
      await txn.wait();
      } 

    const handleRedeemGiCTMT = async (e) => {
      e.preventDefault();
      const txn = await giCTMTContract.redeemGiCTMT()
      await txn.wait();
      } 

    const handleForceLIRedemption = async (e) => {
        e.preventDefault();
        const txn = await liCTMTContract.forceRedeemLiCTMT()
        await txn.wait();
    } 

    const handleForceGIRedemption = async (e) => {
        e.preventDefault();
        const txn = await giCTMTContract.forceRedeemGiCTMT()
        await txn.wait();
    } 

        return(
              <div>
                  <div className="row">
                  <div className="side">
                      
                      <h2>My Fund Provision</h2>
                      <p style={{"fontSize":"12px"}}><b>My Address:</b> {walletAddress}</p> 
                      <p style={{"fontSize":"12px"}}><b>Association Status :</b> {quitStatus}</p>
                      <table className="tableA">
                        <tbody>
                        <tr>
                          <th className="column1" style={{"width":"70%", "textAlign": "center"}}>Stats</th>
                          <th className="column2" style={{"width":"30%", "textAlign": "center"}}>Figure</th>
                          </tr>
                          <tr>
                          <td className="column1">CWJC Balance</td>
                          <td className="column2">{ctmtBalance}</td>
                          </tr>
                          <tr>
                          <td className="column1">CWJC Burned for Support</td>
                          <td className="column2">{CTMTDeposits}</td>
                          </tr>   
                          <tr>
                          <td className="column1">Mountain Fresh Water Pipes For Sale</td>
                          <td className="column2">{minCpCTMT}</td>
                          </tr>                                                                           
                          <tr>
                          <td className="column1">Mountain Fresh Water Pipes Balance</td>
                          <td className="column2">{cpCTMTBalance}</td>
                          </tr>
                          <tr>
                          <td className="column1">Mountain Fresh Water Pipes Sold</td>
                          <td className="column2">{claimedReturns}</td>
                          </tr>
                          <tr>
                          <td className="column1">Total CWJC Returned</td>
                          <td className="column2">{totalSapphireSalt}</td>
                          </tr>                            
                          <tr>
                          <td className="column1">Total Free CWJC Received</td>
                          <td className="column2">{cwsMined}</td>
                          </tr>                          
                          <tr>
                          <td /*style={{"fontSize":"12px"}}*/ className="column1">Claimable CWJC {claimableReturnsButton}</td>
                          <td className="column2">{claimableReturns}</td>
                          </tr>
                          <tr>
                          <td className="column1">Claimable Local Insurance</td>
                          <td className="column2">{claimableLiCTMT}</td>
                          </tr>
                          <tr>
                          <td style={{"fontSize":"11px"}} className="column1" >Claimable Global Insurance <i>({cGiCTMTValue} CWJC)</i></td>
                          <td className="column2">{claimableGiCTMT}</td>
                          </tr>
                          <tr>
                          <td className="column1">Redeemable Local Insurance {redeemableLiCTMTButton}{forceRedeemLIButton}</td>
                          <td className="column2">{redeemableLiCTMT}</td>
                          </tr>
                          <tr>
                          <td style={{"fontSize":"12px"}} className="column1" >Redeemable Global Insurance <i>({rGiCTMTValue} CWJC)</i> {redeemableGiCTMTButton}{forceRedeemGIButton}</td>
                          <td className="column2">{redeemableGiCTMT}</td>
                          </tr>                             
                        </tbody>
                      </table><br/>  
                            <Provideractions />
                  </div>
                  <div className="main">
                      <div>
                          <ChooseManager />
                      </div>
                  </div>                
                  </div>
              </div>
              
          )



}

export default Providers;